import { AxiosResponse } from "axios";
import { axiosInstance } from "src/services/axiosSetup";
import * as API_URL from "src/services/consts/Subscribe"


export function subscribeRequestApi(data: any): Promise<any> {
    return axiosInstance.post(`${API_URL.SUBSCRIBE_URL}`, data).then((d: AxiosResponse) => d.data);
}
